import React, {Component} from 'react';
import Header from "../components/Header/Header";
import bg from '../assets/img/ourLocationsBg.jpg';
import Locations from "../components/Connect/Locations";
import ContactForm from "../components/Connect/ContactForm";
import {AnchorPoint} from "../components/GetToKnow/OurStory";

import hngutils from "../assets/libs/hngutils";

class Connect extends Component {
    constructor (props) {
      super(props);
      
      this.props.data.connect.edges.forEach(edge => {
        hngutils.imageSrcToLocalFile(edge.node.acf.location_image);
      });
    }

    render() {
        const locations = this.props.data.connect.edges;
        const {header} = this.props.data.headerText.edges[0].node.acf;
        return (
          <div>
              <Header title={header} bg={bg}/>
              <Locations locations={locations}/>
              <AnchorPoint id={'contact'}/>
              <ContactForm/>
          </div>
        );
    }
}

export default Connect;

export const connectQuery = graphql`
    query connectQuery {
        headerText: allWordpressPage(filter: {wordpress_id: {eq: 635}}){
            edges {
                node {
                    acf {
                        header
                    }
                }
            }
        }
        connect: allWordpressPost(filter: {acf: {type: {eq: "connect"}}}){
            edges{
                node{
                    acf{
                        address
                        phone_number
                        location_image{
                            source_url
                            alt_text
                            localFile {
                              childImageSharp {
                                original {
                                  src
                                }
                              }
                            }
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/connect.js